<template>
  <span>
    <v-row>
      <v-col>
        <v-btn
          class="ma-2 ml-0"
          depressed
          outlined
          :color="dash_active === 'spklu' ? colorActive : colorInactive"
          @click="dash_active = 'spklu'"
        >
          <v-icon
            left
            :color="dash_active === 'spklu' ? colorActive : colorInactive"
          >
            $ic-house
          </v-icon>
          SPKLU
        </v-btn>
        <!-- <v-btn
          class="ma-2"
          depressed
          outlined
          :color="dash_active==='homecharging' ? colorActive : colorInactive"
          @click="dash_active='homecharging'"
        >
          <v-icon left :color="dash_active==='homecharging' ? colorActive : colorInactive">
            $ic-house
          </v-icon>
          Home Charging
        </v-btn> -->
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-btn
          class="ma-2"
          depressed
          outlined
          :color="colorActive"
          @click="openDialog()"
        >
          <v-icon left :color="colorActive"> $ic-filter </v-icon>
          Filter
        </v-btn>
      </v-col>
    </v-row>
    <span v-if="dash_active === 'spklu'">
      <v-row>
        <v-col v-for="(data, i) in summaryCardsSpklu" :key="i">
          <v-card flat outlined>
            <v-card-text>
              <p>
                <span class="summary-title">{{ data.title }}</span>
                <span
                  v-if="data.id === 'transaksi' || data.id === 'pengguna'"
                  class="summary-value"
                  >{{ formatCurrency(data.value).split(",")[0] }}</span
                >
                <span v-else class="summary-value">{{
                  formatCurrency(data.value)
                }}</span>
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card flat outlined>
            <v-card-title class="pb-0">
              <p>
                <span style="font-weight: 600"
                  >Transaksi
                  {{
                    formattedDateRange ? formattedDateRange : "Hari Ini"
                  }}</span
                >
                <span style="font-color: #9a9a9a; font-size: 14px"
                  >Data Keseluruhan</span
                >
              </p>
            </v-card-title>
            <v-card-text>
              <!-- <v-row>
                <v-col cols="3" class="pb-10">
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                  >
                    Periode
                    <v-icon right>
                      $ic-calendar
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="8" class="text-right">
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                  >Daily</v-btn>
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                    class="ml-2"
                  >Weekly</v-btn>
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                    class="ml-2"
                  >Monthly</v-btn>
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                    class="ml-2"
                  >Yearly</v-btn>
                </v-col>
              </v-row> -->
              <span
                v-if="
                  (this.input.periode === undefined && !isLoading) ||
                  (this.input.periode &&
                    this.input.periode.id === 'hourly' &&
                    !isLoading)
                "
              >
                <LineChartGenerator
                  :chart-options="chartOptionsLine"
                  :chart-data="chartLineDataTransaksi"
                />
              </span>
              <span v-else-if="!isLoading">
                <Bar
                  :chart-options="chartOptionsBar"
                  :chart-data="chartBarDataTransaksi"
                />
              </span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card flat outlined>
            <v-card-title class="pb-0">
              <p>
                <span style="font-weight: 600"
                  >kWh Terjual
                  {{
                    formattedDateRange ? formattedDateRange : "Hari Ini"
                  }}</span
                >
                <span style="font-color: #9a9a9a; font-size: 14px"
                  >Data Keseluruhan</span
                >
              </p>
            </v-card-title>
            <v-card-text>
              <!-- <v-row>
                <v-col cols="3" class="pb-10">
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                  >
                    Periode
                    <v-icon right>
                      $ic-calendar
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="8" class="text-right">
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                  >Daily</v-btn>
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                    class="ml-2"
                  >Weekly</v-btn>
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                    class="ml-2"
                  >Monthly</v-btn>
                  <v-btn
                    small
                    depressed
                    outlined
                    color="#9A9A9A"
                    class="ml-2"
                  >Yearly</v-btn>
                </v-col>
              </v-row> -->
              <span
                v-if="
                  (this.input.periode === undefined && !isLoading) ||
                  (this.input.periode &&
                    this.input.periode.id === 'hourly' &&
                    !isLoading)
                "
              >
                <LineChartGenerator
                  :chart-options="chartOptionsLine"
                  :chart-data="chartLineDataKwh"
                />
              </span>
              <span v-else-if="!isLoading">
                <Bar
                  :chart-options="chartOptionsBar"
                  :chart-data="chartBarDataKwh"
                />
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card flat outlined>
            <v-card-title> Presentase Transaksi </v-card-title>
            <v-card-text>
              <v-row v-for="(data, i) in summaryPercentage" :key="i">
                <v-col>
                  <span class="percentage-value"
                    >Rp {{ formatCurrency(data.incomeNow) }}</span
                  ><br />
                  <span>{{ data.textLeft }}</span>
                </v-col>
                <v-col class="text-right">
                  <v-icon v-if="data.percentage > 0" color="#56A452"
                    >mdi-chevron-up</v-icon
                  >
                  <v-icon v-else-if="data.percentage < 0" color="#DD6068"
                    >mdi-chevron-down</v-icon
                  >
                  <span
                    :class="
                      data.percentage >= 0 ? 'percentage-up' : 'percentage-down'
                    "
                    >{{ formatCurrency(data.percentage) + "%" }}</span
                  ><br />
                  <span>{{
                    data.textRight + formatCurrency(data.incomeBefore)
                  }}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-alert
            border="left"
            colored-border
            :color="colorPicker(data.id)"
            elevation="2"
            v-for="(data, i) in summaryStatus"
            :key="i"
          >
            <v-row>
              <v-col cols="5">
                <span class="summary-alert-value">{{ data.id }}</span
                ><br />
                <span class="summary-alert-title">Data Keseluruhan</span>
              </v-col>
              <v-col cols="2">
                <span class="summary-alert-value">{{ data.spklu }}</span
                ><br />
                <span class="summary-alert-title">SPKLU</span>
              </v-col>
              <v-col cols="2">
                <span class="summary-alert-value">{{ data.charger }}</span
                ><br />
                <span class="summary-alert-title">Charger</span>
              </v-col>
              <v-col cols="2">
                <span class="summary-alert-value">{{ data.connector }}</span
                ><br />
                <span class="summary-alert-title">Connector</span>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
    </span>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>Filter Data</span>
            </v-col>
            <v-col class="text-right">
              <v-btn icon x-small @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">
                  Unit
                </div>
                <v-text-field
                  v-model="input.searchBranch"
                  label="Cari Lokasi"
                  dense
                  solo
                  flat
                  outlined
                  clearable
                >
                </v-text-field>
                <span
                  >Selected:
                  {{
                    input.branch.name ? input.branch.name : "unit belum dipilih"
                  }}
                  <v-icon
                    v-show="input.branch.id"
                    @click="
                      input.branch = {};
                      active = [];
                    "
                    >mdi-close</v-icon
                  >
                </span>
                <div
                  v-show="!input.branch.id"
                  style="overflow-y: scroll; height: 300px"
                >
                  <v-treeview
                    activatable
                    :active="active"
                    :items="tempOptionsBranch"
                    @update:active="treeClick"
                  ></v-treeview>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Nama SPKLU
                </div>
                <v-autocomplete
                  v-model="input.spklu"
                  :items="optionsSpklu"
                  label="Semua SPKLU"
                  dense
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                  return-object
                  :color="colorActive"
                  :search-input.sync="searchSpkluKeyword"
                  :loading="awaitingSearch"
                  clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">
                  Tipe Periode
                </div>
                <v-autocomplete
                  v-model="input.periode"
                  :items="optionsTipePeriode"
                  label="Semua"
                  dense
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                  return-object
                  cache-items
                  :color="colorActive"
                  @change="changeDateRangeType()"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row
              v-if="this.input.periode && this.input.periode.id !== 'yearly'"
            >
              <v-col class="pb-5 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">
                  Periode
                </div>
                <v-menu
                  ref="menuDateRange"
                  v-model="menuDateRange"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDateRange"
                      readonly
                      clearable
                      @click:clear="changeDateRangeType()"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                      flat
                      outlined
                      hide-details
                      append-icon="mdi-calendar"
                      placeholder="Semua"
                      :color="colorActive"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    reactive
                    v-model="dateRange"
                    :active-picker.sync="activePicker"
                    :max="
                      new Date(
                        Date.now() - new Date().getTimezoneOffset() * 60000
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                    locale="id-ID"
                    :color="colorActive"
                    :type="dpTypeChooser()"
                    @click:year="
                      input.periode && input.periode.id === 'monthly'
                        ? setDateRange(dateRange)
                        : ''
                    "
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="input.periode && input.periode.id !== 'monthly'"
                      text
                      :color="colorActive"
                      @click="setDateRange"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed color="#999999" text @click="closeDialog()">
            Kembali
          </v-btn>
          <v-btn
            small
            depressed
            :color="colorActive"
            @click="
              dialog = false;
              reGetChart();
            "
            dark
          >
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { Bar, Line as LineChartGenerator } from "vue-chartjs";
import DashboardService from "@/services/default/DashboardService";
import RefService from "@/services/default/RefService";
import { StorageService } from "@/services/storage.service";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";

const dashboardService = DashboardService.build();
const refService = RefService.build();

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
);
export default {
  name: "Dashboard-SPKLU",
  components: {
    Bar,
    LineChartGenerator,
  },
  data: () => ({
    colorActive: "#2671D9",
    colorInactive: "#9A9A9A",
    dialog: false,
    searchSpkluKeyword: "",
    awaitingSearch: false,
    optionsSpklu: [],
    optionsBranch: [],
    optionsCakupan: [
      { id: "spklu", name: "Per SPKLU" },
      { id: "wilayah", name: "Per Wilayah" },
    ],
    isShowOptionSpklu: true,
    isShowOptionBranch: true,
    tempOptionsBranch: [],
    optionsTipePeriode: [
      { id: "hourly", name: "Hourly" },
      { id: "daily", name: "Daily" },
      // { id: 'weekly', name: 'Weekly' },
      { id: "monthly", name: "Monthly" },
      { id: "yearly", name: "Yearly" },
    ],
    input: {
      cakupan: {},
      periode: { id: "hourly", name: "Hourly" },
      branch: {
        id: "",
        name: "",
      },
      searchBranch: "",
      spklu: { id: "", name: "" },
    },
    active: [],
    menuDateRange: false,
    dateRange: null,
    activePicker: null,
    // dashboard spklu variable
    dash_active: "spklu",
    // chart properties dashboard spklu
    isLoading: false,
    chartLineDataTransaksi: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: "Jumlah Transaksi",
          backgroundColor: "#d4e3f7",
          borderColor: "#2671D9",
          // put chart data here
          data: [],
          fill: "start",
          tension: 0.4,
        },
      ],
    },
    chartBarDataTransaksi: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: "Jumlah Transaksi",
          backgroundColor: "#2671D9",
          // put chart data here
          data: [],
          barThickness: 15,
        },
      ],
    },
    chartOptionsLine: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || "";

              if (label) {
                label += ": ";
              }
              if (context.parsed.y !== null) {
                const isHasDecimal =
                  context.parsed.y - Math.floor(context.parsed.y) !== 0;
                // Indonesian's number format
                if (isHasDecimal) {
                  const value = (context.parsed.y / 1)
                    .toFixed(2)
                    .replace(".", ",");
                  label += value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                } else {
                  label += context.parsed.y
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
              }
              return label;
            },
          },
        },
      },
      scales: {
        y: {
          ticks: {
            // Indonesian's number format
            callback: (label) =>
              `${label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
          },
        },
      },
    },
    chartLineDataKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: "kWh Terjual",
          backgroundColor: "#d4e3f7",
          borderColor: "#2671D9",
          // put chart data here
          data: [],
          fill: "start",
          tension: 0.4,
        },
      ],
    },
    chartBarDataKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: "kWh Terjual",
          backgroundColor: "#2671D9",
          // put chart data here
          data: [],
          barThickness: 15,
        },
      ],
    },
    chartOptionsBar: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || "";

              if (label) {
                label += ": ";
              }
              if (context.parsed.y !== null) {
                const isHasDecimal =
                  context.parsed.y - Math.floor(context.parsed.y) !== 0;
                // Indonesian's number format
                if (isHasDecimal) {
                  const value = (context.parsed.y / 1)
                    .toFixed(2)
                    .replace(".", ",");
                  label += value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                } else {
                  label += context.parsed.y
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
              }
              return label;
            },
          },
        },
      },
      scales: {
        y: {
          ticks: {
            // Indonesian's number format
            callback: (label) =>
              `${label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
          },
        },
      },
    },
    summaryCardsSpklu: [
      { id: "transaksi", title: "Total Transaksi (Order)", value: 0 },
      { id: "kwh", title: "Total kWH Terjual", value: 0 },
      { id: "rupiah", title: "Total Pendapatan (Rp)", value: 0 },
      { id: "pengguna", title: "Pengguna Terdaftar", value: 0 },
    ],
    summaryPercentage: [
      {
        id: "daily",
        textLeft: "Pendapatan Harian",
        textRight: "Hari Sebelumnya Rp ",
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0,
      },
      {
        id: "weekly",
        textLeft: "Pendapatan Mingguan",
        textRight: "Minggu Sebelumnya Rp ",
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0,
      },
      {
        id: "monthly",
        textLeft: "Pendapatan Bulanan",
        textRight: "Bulan Sebelumnya Rp ",
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0,
      },
      {
        id: "yearly",
        textLeft: "Pendapatan Tahunan",
        textRight: "Tahun Sebelumnya Rp ",
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0,
      },
    ],
    summaryStatus: [
      { id: "Aktif", spklu: 0, charger: 0, connector: 0 },
      { id: "Non Aktif", spklu: 0, charger: 0, connector: 0 },
      { id: "SPKLU Non PLN", spklu: 0, charger: 0, connector: 0 },
    ],
  }),
  async created() {
    this.reGetChart();
  },
  computed: {
    formattedDateRange() {
      if (this.dateRange) {
        if (this.input.periode.id === "monthly") {
          return this.dateRange.split("-")[0];
        } else if (
          this.input.periode.id === "hourly" ||
          this.input.periode.id === "daily"
        ) {
          return this.dateRange;
        } else if (this.input.periode.id === "weekly") {
          return this.dateRange.join(" ~ ");
        }
      }
      return "";
    },
  },
  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata();
    const newVal = this.input.branch.id;
    const oldVal = responseAuth.branch.idBranch;

    if (newVal === "") {
      if (responseAuth.branch.name !== "PUSAT") {
        this.input.branch.id = responseAuth.branch.idBranch;
        this.input.branch.name = responseAuth.branch.name;
      }

      this.getOptionsSpklu(oldVal);
      this.reGetChart();
    }
  },
  watch: {
    menuDateRange(val) {
      if (this.input.periode.id === "monthly") {
        val && this.$nextTick(() => (this.activePicker = "YEAR"));
      } else if (this.input.periode.id === "daily") {
        val && this.$nextTick(() => (this.activePicker = "MONTH"));
      } else if (this.input.periode.id === "hourly") {
        val && this.$nextTick(() => (this.activePicker = "DATE"));
      } else {
        val && this.$nextTick(() => (this.activePicker = null));
      }
    },
    // searchSpkluKeyword (val) {
    //   const self = this
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       if (val !== '' && val !== null) {
    //         self.getOptionsSpklu()
    //       }
    //       self.awaitingSearch = false
    //     }, 1000)
    //   }
    //   this.awaitingSearch = true
    // },
    "input.searchBranch": function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch;
      } else {
        this.tempOptionsBranch = this.containComplex(this.optionsBranch, val);
      }
    },
    "input.branch": function (newVal, oldVal) {
      if (newVal.id !== oldVal) {
        this.getOptionsSpklu(newVal.id);
      }
    },
    // 'input.cakupan': function (val) {
    //   if (val.id === 'spklu') {
    //     this.isShowOptionSpklu = true
    //     this.isShowOptionBranch = false
    //   } else if (val.id === 'wilayah') {
    //     this.isShowOptionSpklu = false
    //     this.isShowOptionBranch = true
    //   } else {
    //     this.isShowOptionSpklu = true
    //     this.isShowOptionBranch = true
    //   }
    // }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.isLoading = false;
    },
    openDialog() {
      this.getOptionsBranch();
      this.dialog = true;
      this.isLoading = true;
    },
    setDateRange(date) {
      this.$refs.menuDateRange.save(date);
    },
    async getCardData(param) {
      const response = await dashboardService.getCardDashboardSpklu(param);
      const { data } = response;
      if (data.success !== true) return;

      for (let i = 0; i < this.summaryCardsSpklu.length; i++) {
        this.summaryCardsSpklu[i].value =
          data.data[this.summaryCardsSpklu[i].id];
      }
    },
    async getChartData(param) {
      const response = await dashboardService.getChartDashboardSpklu(param);
      const { data } = response;
      if (data.success !== true) return;

      if (
        this.input.periode === undefined ||
        this.input.periode.id === "hourly"
      ) {
        this.chartLineDataTransaksi.labels = [];
        this.chartLineDataTransaksi.datasets[0].data = [];
        this.chartLineDataKwh.labels = [];
        this.chartLineDataKwh.datasets[0].data = [];

        // set data and y axis label for chart line
        for (let i = 0; i < data.data.length; i++) {
          // hours label format
          const label = data.data[i].periode.toString() + ".00";

          this.chartLineDataTransaksi.labels.push(label);
          this.chartLineDataTransaksi.datasets[0].data.push(
            data.data[i].transaksi
          );

          this.chartLineDataKwh.labels.push(label);
          this.chartLineDataKwh.datasets[0].data.push(data.data[i].kwh);
        }
      } else {
        this.chartBarDataTransaksi.labels = [];
        this.chartBarDataTransaksi.datasets[0].data = [];
        this.chartBarDataKwh.labels = [];
        this.chartBarDataKwh.datasets[0].data = [];

        // set data and y axis label for chart bar
        for (let i = 0; i < data.data.length; i++) {
          const label = data.data[i].periode;

          this.chartBarDataTransaksi.labels.push(label);
          this.chartBarDataTransaksi.datasets[0].data.push(
            data.data[i].transaksi
          );

          this.chartBarDataKwh.labels.push(label);
          this.chartBarDataKwh.datasets[0].data.push(data.data[i].kwh);
        }
      }
    },
    async getTransactionPercentage(param) {
      const response = await dashboardService.getSpkluTransactionPercentage(
        param
      );
      const { data } = response;
      if (data.success !== true) return;

      for (let i = 0; i < this.summaryPercentage.length; i++) {
        const key = data.data[i].ket.toLowerCase();
        const index = this.summaryPercentage.findIndex((x) => x.id === key);

        this.summaryPercentage[index].incomeNow = data.data[i].sekarang;
        this.summaryPercentage[index].incomeBefore = data.data[i].sebelumnya;
        this.summaryPercentage[index].percentage = data.data[i].persen;
      }
    },
    async getStatusData(param) {
      const response = await dashboardService.getSpkluStatus(param);
      const { data } = response;
      if (data.success !== true) return;

      for (let i = 0; i < this.summaryStatus.length; i++) {
        const key = data.data[i].status;
        const index = this.summaryStatus.findIndex((x) => x.id === key);

        this.summaryStatus[index].spklu = data.data[i].spklu;
        this.summaryStatus[index].charger = data.data[i].charger;
        this.summaryStatus[index].connector = data.data[i].connector;
      }
    },
    async reGetChart() {
      const dateNow = new Date().toISOString().split("T")[0];
      let q = "";
      const periode = this.formattedDateRange
        ? this.formattedDateRange.split("-").join("")
        : dateNow.split("-").join("");

      if (this.input.spklu) {
        q = this.input.spklu.id;
      } else if (this.input.branch) {
        q = this.input.branch.id;
      }

      const param = {
        periodeType: this.input.periode.id,
        periode: periode,
        q: q,
      };

      await this.getCardData(param);
      await this.getChartData(param);
      await this.getTransactionPercentage(param);
      await this.getStatusData({ q: param.q });
      this.isLoading = false;
    },
    colorPicker(status) {
      if (status === "Aktif") return "#397E5D";
      else if (status === "Non Aktif") return "#DD6068";
      else return "#2671D9";
    },
    async getOptionsSpklu(id) {
      this.paging.page = 0;
      this.paging.size = 20;

      // const param = Object.assign({ q: this.searchSpkluKeyword }, this.paging)
      const param = Object.assign({ q: id }, this.paging);
      const response = await refService.getSpkluList(param);
      const { data } = response;
      if (data.success !== true) return;

      if (this.input.branch.id !== param.q || param.q === undefined) {
        this.optionsSpklu = [];
      } else {
        this.optionsSpklu = data.data.content.map((data) => {
          return {
            id: data.idSpklu,
            name: data.spkluName,
          };
        });
      }
    },
    async getOptionsBranch() {
      const branch = JSON.parse(localStorage.getItem("branch_list"))?.data;

      if (branch) {
        this.optionsBranch = branch;
        this.tempOptionsBranch = branch;
      } else {
        const param = {
          companyId: 1,
          branchId: "",
        };
        const response = await refService.getBranchList(param);
        const {
          data: { data },
        } = response;

        const temp = data.map((item) => {
          // remap level 1
          item.child = item.child.map((item2) => {
            // remap level 2
            item2.child = item2.child.map((item3) => {
              // remap level 3
              item3.child = item3.child.map((item4) => {
                // remap level 4
                return {
                  id: item4.id,
                  name: item4.id.split("").join(".") + " - " + item4.name,
                  children: item4.child,
                };
              });
              return {
                id: item3.id,
                name: item3.id.split("").join(".") + " - " + item3.name,
                children: item3.child,
              };
            });
            return {
              id: item2.id,
              name: item2.id.split("").join(".") + " - " + item2.name,
              children: item2.child,
            };
          });
          return {
            id: item.id,
            name: item.id.split("").join(".") + " - " + item.name,
            children: item.child,
          };
        });

        this.optionsBranch = temp;
        this.tempOptionsBranch = temp;

        localStorage.setItem(
          "branch_list",
          JSON.stringify({
            data: temp,
          })
        );
      }
    },
    treeClick(value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem("branch_list"))?.data;
        this.input.branch = this.findComplex(branch, value[0]);
        this.input.spklu = {};
      }
    },
    changeDateRangeType() {
      // this.dateRange = null
      // if (this.input.periode.id === 'hourly' || this.input.periode.id === 'daily' || this.input.periode.id === 'monthly' || this.input.periode.id === 'yearly') {
      //   this.dateRange = null
      // } else {
      //   // for weekly
      //   this.dateRange = []
      // }
    },
    dpTypeChooser() {
      if (
        (this.input.periode && this.input.periode.id === "monthly") ||
        (this.input.periode && this.input.periode.id === "hourly")
      ) {
        return undefined;
      } else if (this.input.periode && this.input.periode.id === "daily") {
        return "month";
      } else return "date";
    },
  },
};
</script>
<style scoped>
.summary-title {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  padding: 5% 5% 0% 5%;
}

.summary-value {
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  padding: 10% 5% 0% 5%;
}

p span {
  display: block;
}

.percentage-value {
  font-weight: 700;
  font-size: 14px;
  color: #333333;
}

.percentage-up {
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  color: #56a452;
}

.percentage-down {
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  color: #dd6068;
}

.summary-alert-title {
  font-weight: 400;
  font-size: 14px;
  color: #9a9a9a;
}

.summary-alert-value {
  font-weight: 600;
  font-size: 18px;
  color: #000000;
}
</style>
